import { ReactComponent as align_center } from "./align_center.svg"
import { ReactComponent as align_horizontal } from "./align_horizontal.svg"
import { ReactComponent as align_vertical } from "./align_vertical.svg"
import { ReactComponent as arrange_backward } from "./arrange_backward.svg"
import { ReactComponent as arrange_forward } from "./arrange_forward.svg"
import { ReactComponent as arrange_front } from "./arrange_front.svg"
import { ReactComponent as bold } from "./bold.svg"
import { ReactComponent as border } from "./border.svg"
import { ReactComponent as color } from "./color.svg"
import { ReactComponent as imageSize } from "./imageSize.svg"
import { ReactComponent as italic } from "./italic.svg"
import { ReactComponent as justify_center } from "./justify_center.svg"
import { ReactComponent as justify_left } from "./justify_left.svg"
import { ReactComponent as justify_right } from "./justify_right.svg"
import { ReactComponent as mirrored } from "./mirrored.svg"
import { ReactComponent as none } from "./none.svg"
import { ReactComponent as reset } from "./reset.svg"
import { ReactComponent as rotate_left } from "./rotate_left.svg"
import { ReactComponent as rotate_right } from "./rotate_right.svg"
import { ReactComponent as symbols } from "./symbols.svg"
import { ReactComponent as textSize } from "./textSize.svg"
import { ReactComponent as underlined } from "./underlined.svg"

const icons: IconMap = {
  arrange_front,
  arrange_forward,
  arrange_backward,
  align_center,
  align_horizontal,
  align_vertical,
  bold,
  border,
  color,
  italic,
  justify_center,
  justify_left,
  justify_right,
  mirrored,
  symbols,
  textSize,
  imageSize,
  underlined,
  reset,
  rotate_left,
  rotate_right,
  none,
}

export default icons
